export const ARTIST_WIZARD_CONTEXTS = {
  GUEST_DJ: 'guest-dj',
  PROMO_POOL: 'promo-pool',
  SOUNDCLOUD_CONNECT: 'soundcloud-connect',
  SPOTIFY_CONNECT: 'spotify-connect',
  APPLE_MUSIC_CONNECT: 'apple-music-connect',
  LABEL_RELEASE: 'label-release'
} as const;

export const WIZARD_STEP_IDS = {
  OVERVIEW: 'overview',
  ARTIST_NAME: 'artist-name',
  ARTIST_MEMBERS: 'artist-members',
  SOUNDCLOUD: `soundcloud-connect`,
  SPOTIFY: `spotify-connect`,
  APPLE_MUSIC: `apple-music-connect`
} as const;
